import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent {
  error: string;

  constructor(private router: Router) {
    const navigation = this.router.currentNavigation();
    this.error = navigation.extras.state?.error || 'error.linkError';
  }
}
